import React, { useCallback, useState } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import { MultiSelectDropDown } from '../../MultiSelectDropDown'
import { CommodityField } from '@commonComponents/formComponents/CommodityCodeField'
import PopUpIcon from '@commonComponents/formComponents/PopUpIcon'
import { useTranslation } from '@hooks/useTranslation'

const inputOrSearchableDropdownField = (fieldType, dropdownType) => {
  if (fieldType === 'searchableDropdown') {
    return {
      searchable: true,
      fieldType: fieldType,
      dropdownType: dropdownType
    }
  } else if (fieldType === 'input') {
    return {
      fieldType: fieldType
    }
  }
}

export const MerchForm2 = React.memo(
  ({
    dataSource: {
      id: merchandiseId,
      invoiceId,
      commodityCode,
      taricCode,
      dangerousGoodsCodesList,
      dispatchRegion,
      preference,
      prefOrigin,
      taricAdditionalCodesList,
      nationalAdditionalCodesList,
    },
    onSelect,
    version,
    isImportShipment,
    serviceType,
    onBlur,
    onChange,
    regionDispatchList,
    copyDocument,
    validateLineItem,
    submit
  }) => {
    const onChangeHandler = useCallback(
      ({ target: { value, name } }) => onChange(value, name),
      [merchandiseId, onChange]
    )
    const onDropDownChange = useCallback(
      (e, { value, name }) => onSelect(value, name),
      [merchandiseId, onSelect]
    )
    const onBlurHandler = useCallback(
      ({ target: { value, name } }) => onBlur(value, name),
      [merchandiseId, onBlur]
    )
    const translate = useTranslation();
    const [showModal, setShowModal] = useState(false)
    return (
      <>
        {!isImportShipment && (
          <Grid.Column width={'4'} className='multiSelect_DropDown'>
            <MultiSelectDropDown
              label='UNDG_NUMBER'
              merchandiseId={merchandiseId}
              invoiceId={invoiceId}
              translate={translate}
              searchable={true}
              valueKey='undgCode'
              fieldType='searchableDropdown'
              tableName='dangerousGoodsCodesList'
              dropdownType='dangerousGoods'
              dataList={dangerousGoodsCodesList}
              copyDocument={copyDocument}
            />
          </Grid.Column>
        )}
        <CommodityField
          id={`commodityCode-${invoiceId}-${merchandiseId}`}
          htsEnabled={true}
          htsBoxNumber='6/14'
          taricBoxNumber='6/15'
          label='COM_NOMECLATURE'
          htsCode={commodityCode}
          version={version}
          commodityCode={commodityCode}
          taricCode={taricCode}
          taricWidth='2'
          isImportShipment={isImportShipment}
          serviceType={serviceType}
          taricLabel='TARIC_CODE'
          translate={translate}
          showModal={showModal}
          setShowModal={setShowModal}
          submit={submit}
          onHtsPopupChange={({ htsCode, taricCode }) => {
            onChangeHandler({ target: { name: 'commodityCode', value: htsCode } })
            onBlurHandler({ target: { value: htsCode, name: 'commodityCode' } })
            if (taricCode) {
              onChangeHandler({ target: { name: 'taricCode', value: taricCode } })
              onBlurHandler({ target: { value: taricCode, name: 'taricCode' } })
            }
          }}
          onBlur={({ taricCode, htsCode }) => {
            !taricCode && validateLineItem && validateLineItem('commodityCode', htsCode)
            !htsCode && validateLineItem && validateLineItem('commodityCode', taricCode)
            !taricCode && onBlurHandler({ target: { value: htsCode, name: 'commodityCode' } })
            !htsCode && onBlurHandler({ target: { value: taricCode, name: 'taricCode' } })
          }}
          onHtsChange={(value) => onChangeHandler({ target: { name: 'commodityCode', value } })}
          onTaricChange={(value) => onChangeHandler({ target: { name: 'taricCode', value } })}
        />
        {/* <Grid.Column>
          <InputField
            id={`combinedNomenclature${merchandiseId}`}
            type='text'
            label={translate('COM_NOMENCLATURE', { ns: ['default', 'items'] }) + '(1-8)'}
            boxNumber='6/14'
            value={commodityCode}
            name='commodityCode'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column> */}
        <Grid.Column width='3' className='multiSelect_DropDown'>
          <MultiSelectDropDown
            label={'TARIC_EU_ADD_CODE'}
            merchandiseId={merchandiseId}
            invoiceId={invoiceId}
            translate={translate}
            valueKey='code'
            fieldType={'input'}
            labelIcon={
              <PopUpIcon
                icon='info circle'
                position='top right'
                popupText={translate('FOUR_DIGITS_MESSAGE')}
              />
            }
            boxNumber={'6/15'}
            tableName='taricAdditionalCodesList'
            dataList={taricAdditionalCodesList}
          />
        </Grid.Column>
        <Grid.Column width='3' className='multiSelect_DropDown'>
          <MultiSelectDropDown
            label='NATIONAL_ADD_CODE'
            merchandiseId={merchandiseId}
            invoiceId={invoiceId}
            translate={translate}
            boxNumber='6/17'
            valueKey='code'
            labelIcon={
              <PopUpIcon icon='info circle' popupText={translate('FOUR_DIGITS_MESSAGE')} />
            }
            fieldType={'input'}
            tableName='nationalAdditionalCodesList'
            dataList={nationalAdditionalCodesList}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`prefOrigin-${invoiceId}-${merchandiseId}`}
            type='text'
            label='PREFERENTIAL_ORIGIN'
            boxNumber='5/16'
            value={prefOrigin}
            name='prefOrigin'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <DropDown
            isLabel={true}
            id={`regionOfDispatch-${invoiceId}-${merchandiseId}`}
            type='text'
            label='REGION_OF_DISPATCH'
            value={dispatchRegion}
            name='dispatchRegion'
            data={regionDispatchList}
            clearable
            onChange={onDropDownChange}
          />
        </Grid.Column>
      </>
    )
  }
)

MerchForm2.defaultProps = {
  translate: (value) => value,
}
